import React, { Suspense, useEffect } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import "./App.css";
import Home from "./pages/Home";
import Header from "./components/Header";
import RoadMap from "./pages/RoadMap";
import AboutUs from "./pages/AboutUs";
import NotFoundPage from "./pages/404";
import Resources from "./pages/Resources";
import ContactUs from "./pages/ContactUs";
import Privacy from "./pages/Privacy";
import { CircularProgress } from "@material-ui/core";
import ReactGA from "react-ga";

const Footer = React.lazy(() => import("./components/Footer"));

function App() {
  useEffect(() => {
    ReactGA.initialize("UA-205742455-1");

    ReactGA.pageview(window.location.pathname + window.location.search);
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <Header />
        <Switch>
          <Route exact path="/" component={Home} />
          <Route exact path="/resources" component={Resources} />
          <Route exact path="/toolkit" component={RoadMap} />
          <Route exact path="/aboutus" component={AboutUs} />
          <Route exact path="/contact-us" component={ContactUs} />
          <Route exact path="/privacy-policy" component={Privacy} />
          <Route component={NotFoundPage} />
        </Switch>
        <Suspense fallback={<CircularProgress />}>
          <Footer />
        </Suspense>
      </BrowserRouter>
    </div>
  );
}

export default App;
